<div class="dbg-overlay">
  <div class="dbg-panel">
    <div class="dbg-title">
      <h2>Debug{{ inspectedName ? ' — ' + inspectedName : ' — current objects' }}</h2>
      <button type="button" class="dbg-close" (click)="closeDialog?.()" aria-label="Close">
        ×
      </button>
    </div>

    <div class="dbg-toolbar">
      <span class="dbg-label">expand:</span>
      <button type="button" class="dbg-btn" (click)="collapseAll()">collapse all</button>
      <button type="button" class="dbg-btn" (click)="expandToLevel(1)">1</button>
      <button type="button" class="dbg-btn" (click)="expandToLevel(3)">3</button>
      <button type="button" class="dbg-btn" (click)="expandToLevel(5)">5</button>
      <button type="button" class="dbg-btn" (click)="expandToLevel(7)">7</button>
      <button type="button" class="dbg-btn" (click)="expandAll()">expand all</button>
      <div class="dbg-search">
        <input
          type="search"
          placeholder="search e.g. *pr*ce*"
          [value]="query"
          (input)="onSearch($any($event.target).value)"
        />
        <button
          type="button"
          class="dbg-btn"
          aria-label="Clear search"
          [disabled]="!query"
          (click)="onSearch('')"
        >
          ✕
        </button>
      </div>
    </div>

    <div class="dbg-body">
      @if (error) {
        <div class="dbg-error"><strong>collection failed:</strong> {{ error }}</div>
      }
      @if (!error && !displayCards.length) {
        <p class="dbg-empty">
          {{ query.trim() ? 'No matches for "' + query + '".' : 'No current objects.' }}
        </p>
      }
      @for (card of displayCards; track $index) {
        <div class="dbg-card">
          <div class="dbg-card-header">
            <strong>
              <span
                class="dbg-toggle"
                role="button"
                tabindex="0"
                (click)="card.expanded.set(!card.expanded())"
                (keydown.enter)="card.expanded.set(!card.expanded())"
                (keydown.space)="card.expanded.set(!card.expanded())"
                >{{ card.expanded() ? '▼' : '►' }}</span
              >
              {{ card.title }}
            </strong>
            <span class="dbg-muted">{{ card.className }}</span>
            <div class="dbg-card-btns">
              <button type="button" class="dbg-btn" (click)="collapseCardRows(card)">
                collapse all
              </button>
              <button type="button" class="dbg-btn" (click)="expandCardToLevel(card, 1)">1</button>
              <button type="button" class="dbg-btn" (click)="expandCardToLevel(card, 3)">3</button>
              <button type="button" class="dbg-btn" (click)="expandCardToLevel(card, 5)">5</button>
              <button type="button" class="dbg-btn" (click)="expandCardToLevel(card, 7)">7</button>
              <button type="button" class="dbg-btn" (click)="expandCardAll(card)">
                expand all
              </button>
            </div>
          </div>
          @if (card.expanded()) {
            <div class="dbg-card-body">
              <ng-container
                [ngTemplateOutlet]="nodeTable"
                [ngTemplateOutletContext]="{$implicit: card.rows}"
              />
            </div>
          }
        </div>
      }
    </div>
  </div>
</div>

<ng-template #nodeTable let-nodes>
  <table class="dbg-table">
    <tbody>
      @for (node of nodes; track $index) {
        <tr>
          @if (node.children) {
            <td class="dbg-field">
              <code>
                <span
                  class="dbg-toggle"
                  role="button"
                  tabindex="0"
                  (click)="node.expanded.set(!node.expanded())"
                  (keydown.enter)="node.expanded.set(!node.expanded())"
                  (keydown.space)="node.expanded.set(!node.expanded())"
                  >{{ node.expanded() ? '▼' : '►' }}</span
                >
                @if (node.instance) {
                  <span
                    class="dbg-inspect"
                    role="button"
                    tabindex="0"
                    title="Inspect this component"
                    (click)="inspectNode(node)"
                    (keydown.enter)="inspectNode(node)"
                    (keydown.space)="inspectNode(node)"
                    >{{ node.field }}</span
                  >
                } @else {
                  {{ node.field }}
                }
              </code>
              <span class="dbg-muted">{{ node.className }}</span>
            </td>
            <td class="dbg-val">
              @if (node.expanded()) {
                <ng-container
                  [ngTemplateOutlet]="nodeTable"
                  [ngTemplateOutletContext]="{$implicit: node.children}"
                />
              } @else {
                <code
                  class="dbg-summary"
                  role="button"
                  tabindex="0"
                  (click)="node.expanded.set(true)"
                  (keydown.enter)="node.expanded.set(true)"
                  (keydown.space)="node.expanded.set(true)"
                  >{{ node.summary }}</code
                >
              }
            </td>
          } @else {
            <td class="dbg-field">
              <code>{{ node.field }}</code>
            </td>
            <td class="dbg-val">
              <code>{{ node.value }}</code>
            </td>
          }
        </tr>
      }
    </tbody>
  </table>
</ng-template>
